export const Roles = {
  ADMIN: "Admin",
  ASSESSOR: "Assessor",
  VENDOR: "Vendor",
  LEADASSESSOR: "Lead Assessor",
};

export const TypesOfCompanyData = {
  // EmployeeData: "Employee Data",
  AuthenticationCredentialsORInternetEncryptionKey:
    "Authentication Credentials or Internet Encryption key",
  SourceCode: "Source Code",
  Vulnerabilities: "Vulnerabilities",
  FinancialOrCommercialData: "Financial / Commercial Data",
  IntellectualPropertyData: "Intellectual Property Data",
  MarketingData: "Marketing Data",
  BusinessData: "Business Data",
  RegulatoryOrComplianceLicensingData: "Regulatory / Compliance Licensing Data",
  NoDataInvolved: "No Data Involved",
  NoneOfTheAbove: "None of the Above",
  IsTherePISPIInvolvedInThisProject:
    "Is there a PI/SPI involved in this project?",
};

export const TypesOfCustomerData = {
  PCI: "PCI (Payment Card Industry Data)",
  // PII: "Personal Identifiable Information (PII)",
  // SPI: "Sensitive Personal Identifiable Information (SPI)",
  CustomerPartnerProprietaryInformation:
    "Customer & Partner Proprietary Information",
  NoDataInvolved: "No Data Involved",
  NoneOfTheAbove: "None of the Above",
  IsTherePISPIInvolvedInThisProject:
    "Is there a PI/SPI involved in this project?",
};

export const privacyQuestionnaire = [
  {
    questionId: 1,
    questionName: "Privacy Program including Policy",
    answer: "",
    icon: "PrivacyProgram",
  },
  {
    questionId: 2,
    questionName: "PI/SPI are not used in the test environment",
    answer: "",
    icon: "Coded",
  },
  {
    questionId: 3,
    questionName: "Privacy Impact assessment",
    answer: "",
    icon: "PrivacyAssessment",
  },
  {
    questionId: 4,
    questionName: "Comply with DSARs (Data Subject Access Requests)",
    answer: "",
    icon: "DASR",
  },
  {
    questionId: 5,
    questionName: "Privacy Awareness Training",
    answer: "",
    icon: "Training",
  },
  {
    questionId: 6,
    questionName: "Strict Controls to protect PI/SPI",
    answer: "",
    icon: "Geography",
  },
  {
    questionId: 7,
    questionName: "Fourth party access to PI/SPI",
    answer: "",
    icon: "FourthPartyAccess",
  },
  {
    questionId: 8,
    questionName: "Consent from Data Subject",
    answer: "",
    icon: "Consent",
  },
  {
    questionId: 9,
    questionName: "Fourth Party Privacy assessment",
    answer: "",
    icon: "PrivacyAssessment",
  },
  {
    questionId: 10,
    questionName: "SPI/PHI Masked/Anonymized/coded",
    answer: "",
    icon: "Coded",
  },
  {
    questionId: 11,
    questionName: "Clean history on Privacy complaints or incidents",
    answer: "",
    icon: "SecurityControls",
  },
  {
    questionId: 12,
    questionName: "PI/SPI destroyed or erased at the end",
    answer: "",
    icon: "DataDestruction",
  },
  {
    questionId: 13,
    questionName: "Data Residency controls",
    answer: "",
    icon: "DataResidency",
  },
  {
    questionId: 14,
    questionName: "PI/SPI Encrypted with AES 256 or TLS 1.2",
    answer: "",
    icon: "Encryption",
  },
  {
    questionId: 15,
    questionName: "Logging & monitoring for PI Data",
    answer: "",
    icon: "Monitoring",
  },
  {
    questionId: 16,
    questionName: "AI does not use PI/SPI for decision making",
    answer: "",
    icon: "ArtificialIntelligence",
  },
];

export const mitreChartData = [
  {
    id: 1,
    name: "Reconnaissance",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
  {
    id: 2,
    name: "Resource Development",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
  {
    id: 3,
    name: "Initial Access",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
  {
    id: 4,
    name: "Execution",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
  {
    id: 5,
    name: "Persistence",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
  {
    id: 6,
    name: "Privilege Escalation",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
  {
    id: 7,
    name: "Defense Evasion",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
  {
    id: 8,
    name: "Credential Access",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
  {
    id: 9,
    name: "Discovery",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
  {
    id: 10,
    name: "Lateral Movement",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
  {
    id: 11,
    name: "Collection",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
  {
    id: 12,
    name: "Command and Control",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
  {
    id: 13,
    name: "Exfiltration",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
  {
    id: 14,
    name: "Impact",
    vendorCoverage: 0,
    industryCoverage: 0,
  },
];

export const domainCoverageList = [
  {
    id: 1,
    domainName: "Access Control",
    coverage: 0,
  },
  {
    id: 2,
    domainName: "Application Security",
    coverage: 0,
  },
  {
    id: 3,
    domainName: "Asset Management",
    coverage: 0,
  },
  {
    id: 4,
    domainName: "Business Continuity Management",
    coverage: 0,
  },
  {
    id: 5,
    domainName: "Cloud",
    coverage: 0,
  },
  {
    id: 6,
    domainName: "Communication and Operation Management",
    coverage: 0,
  },
  {
    id: 7,
    domainName: "Communication Security",
    coverage: 0,
  },
  {
    id: 8,
    domainName: "Compliance",
    coverage: 0,
  },
  {
    id: 9,
    domainName: "Cryptography",
    coverage: 0,
  },
  {
    id: 10,
    domainName: "Human resource Security",
    coverage: 0,
  },
  {
    id: 11,
    domainName: "Incident Management",
    coverage: 0,
  },
  {
    id: 12,
    domainName: "Information System Acquisition development & maintenance",
    coverage: 0,
  },
  {
    id: 13,
    domainName: "Operation Management",
    coverage: 0,
  },
  {
    id: 14,
    domainName: "Organisation of Information Security",
    coverage: 0,
  },
  {
    id: 15,
    domainName: "Physical and Environmental security",
    coverage: 0,
  },
  {
    id: 16,
    domainName: "Privacy",
    coverage: 0,
  },
  {
    id: 17,
    domainName: "Risk management",
    coverage: 0,
  },
  {
    id: 18,
    domainName: "Security Organization",
    coverage: 0,
  },
  {
    id: 19,
    domainName: "Server Security",
    coverage: 0,
  },
  {
    id: 20,
    domainName: "Supplier Management",
    coverage: 0,
  },
];

export const nistList = [
  {
    id: 0,
    categoryName: "Govern",
    score: 0,
    targetScore: 0,
  },
  {
    id: 1,
    categoryName: "Identify",
    score: 0,
    targetScore: 0,
  },
  {
    id: 2,
    categoryName: "Protect",
    score: 0,
    targetScore: 0,
  },
  {
    id: 3,
    categoryName: "Detect",
    score: 0,
    targetScore: 0,
  },
  {
    id: 4,
    categoryName: "Respond",
    score: 0,
    targetScore: 0,
  },
  {
    id: 5,
    categoryName: "Recover",
    score: 0,
    targetScore: 0,
  },
];

export const domainSummaryCardsList = [
  {
    icon: '<?xml version="1.0" standalone="no"?>\n    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"\n     "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">\n    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"\n     width="920.000000pt" height="920.000000pt" viewBox="0 0 920.000000 920.000000"\n     preserveAspectRatio="xMidYMid meet">\n    \n    <g transform="translate(0.000000,920.000000) scale(0.100000,-0.100000)"\n    fill="currentColor" stroke="none">\n    <path d="M4503 9185 c-29 -9 -870 -242 -1870 -520 -1000 -278 -1836 -513\n    -1858 -524 -97 -45 -149 -118 -170 -238 -29 -165 -73 -674 -96 -1103 -16 -290\n    -16 -1095 0 -1360 61 -1047 217 -1835 493 -2494 187 -449 446 -832 874 -1297\n    652 -706 1556 -1286 2479 -1590 142 -47 169 -52 245 -52 76 0 103 5 245 52\n    684 225 1370 607 1940 1081 405 336 811 781 1081 1185 480 715 743 1709 825\n    3115 16 265 16 1070 0 1360 -23 429 -67 938 -96 1103 -21 120 -73 193 -170\n    238 -72 34 -3745 1050 -3810 1054 -35 3 -82 -2 -112 -10z m2092 -2610 c65 -31\n    412 -379 445 -445 32 -62 38 -161 15 -231 -16 -52 -73 -110 -1324 -1363 -1058\n    -1060 -1315 -1313 -1356 -1332 -69 -33 -180 -33 -247 -1 -68 32 -1674 1631\n    -1707 1700 -32 65 -38 149 -16 223 16 56 26 68 222 266 233 234 256 250 373\n    250 127 0 108 15 705 -582 l540 -540 1015 1014 c558 558 1031 1022 1050 1032\n    100 50 195 53 285 9z"/>\n    </g>\n    </svg>\n    ',
    name: "Security Testing",
    id: 1,
    questionsList: [
      {
        question: "Penetration Testing Performed",
        id: 1,
        answer: "yes",
      },
      {
        question: "Defined Remediation Process",
        id: 2,
        answer: "no",
      },
      {
        question: "Tested Within Last 12 Months",
        id: 3,
        answer: "no",
      },
    ],
  },
  {
    icon: '<?xml version="1.0" standalone="no"?>\n    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"\n     "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">\n    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"\n     width="2048.000000pt" height="2048.000000pt" viewBox="0 0 2048.000000 2048.000000"\n     preserveAspectRatio="xMidYMid meet">\n    \n    <g transform="translate(0.000000,2048.000000) scale(0.100000,-0.100000)"\n    fill="currentColor" stroke="none">\n    <path d="M2765 18414 c-248 -45 -463 -155 -644 -329 -188 -181 -311 -408 -362\n    -670 -21 -105 -21 -14245 0 -14350 88 -450 407 -816 830 -955 202 -66 -229\n    -61 5214 -58 l4928 3 -90 67 c-309 231 -642 574 -874 898 -178 249 -383 622\n    -495 900 -376 935 -412 1977 -102 2935 198 609 555 1200 1005 1664 682 702\n    1586 1150 2575 1275 212 27 506 38 716 26 104 -5 192 -10 197 -10 4 0 6 834 5\n    1853 l-3 1852 -1940 5 -1940 5 -81 22 c-229 62 -408 160 -567 312 -185 176\n    -299 382 -363 651 -17 70 -18 193 -21 1998 l-3 1922 -3953 -1 c-3397 -1 -3963\n    -3 -4032 -15z m6211 -4085 c176 -32 306 -165 337 -342 29 -173 -65 -347 -230\n    -429 l-68 -33 -1950 0 -1950 0 -65 32 c-124 61 -208 174 -232 310 -36 211 114\n    419 332 462 69 13 3753 14 3826 0z m3086 -2460 c154 -33 282 -158 317 -310 47\n    -203 -77 -417 -276 -479 -65 -20 -85 -20 -3504 -20 l-3440 0 -61 21 c-291 98\n    -380 459 -165 673 29 30 72 63 95 75 103 53 -115 50 3564 50 2494 1 3431 -2\n    3470 -10z m-1603 -2468 c169 -53 279 -190 289 -362 12 -208 -123 -385 -326\n    -428 -38 -8 -776 -11 -2645 -11 -2804 0 -2643 -3 -2749 51 -23 12 -66 45 -95\n    75 -214 214 -127 573 163 673 59 20 70 20 2681 21 2545 0 2623 -1 2682 -19z\n    m-808 -2461 c76 -23 149 -77 201 -145 86 -114 103 -285 40 -416 -58 -121 -178\n    -209 -314 -230 -40 -6 -880 -9 -2248 -7 l-2185 3 -59 22 c-184 70 -299 261\n    -268 446 27 156 139 287 285 332 34 11 455 14 2263 14 2189 1 2223 1 2285 -19z"/>\n    <path d="M11570 16450 c0 -1909 -3 -1801 57 -1913 34 -61 107 -128 181 -164\n    l57 -28 1360 -3 c748 -1 1548 -1 1778 0 l417 3 -1925 1925 -1925 1925 0 -1745z"/>\n    <path d="M15010 9004 c-387 -34 -732 -115 -1061 -249 -1102 -450 -1911 -1447\n    -2119 -2615 -67 -381 -67 -840 0 -1220 152 -848 626 -1627 1309 -2149 501\n    -383 1057 -612 1697 -698 164 -22 646 -25 804 -5 687 87 1270 330 1795 748\n    140 112 426 398 534 534 429 541 673 1133 753 1825 16 143 16 568 -1 715 -93\n    823 -452 1561 -1038 2131 -550 535 -1235 865 -2003 965 -119 15 -565 27 -670\n    18z m361 -1700 c75 -22 129 -56 184 -115 151 -162 147 -408 -9 -565 -168 -167\n    -427 -160 -591 17 -76 83 -99 146 -100 274 0 92 3 105 32 167 87 185 292 279\n    484 222z m25 -1136 c116 -42 203 -129 247 -244 l22 -59 3 -864 c2 -556 -1\n    -883 -8 -919 -24 -131 -112 -247 -229 -305 -61 -29 -73 -32 -171 -32 -98 0\n    -110 2 -172 32 -88 41 -160 113 -201 201 l-32 67 -3 899 c-2 800 -1 906 14\n    955 64 225 311 350 530 269z"/>\n    </g>\n    </svg>\n    ',
    name: "Information Security",
    questionsList: [
      {
        question: "Data is Encrypted",
        answer: "yes",
        id: 1,
      },
      {
        question: "Server/Network Security",
        answer: "no",
        id: 2,
      },
      {
        question: "Password Policies",
        answer: "yes",
        id: 3,
      },
    ],
    id: 2,
  },
  {
    icon: '<?xml version="1.0" standalone="no"?>\n    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"\n     "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">\n    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"\n     width="2048.000000pt" height="2048.000000pt" viewBox="0 0 2048.000000 2048.000000"\n     preserveAspectRatio="xMidYMid meet">\n    \n    <g transform="translate(0.000000,2048.000000) scale(0.100000,-0.100000)"\n    fill="currentColor" stroke="none">\n    <path d="M10121 20464 c-129 -35 -249 -132 -309 -250 -16 -32 -181 -392 -367\n    -799 -186 -407 -342 -745 -349 -751 -6 -7 -375 -53 -864 -108 -469 -54 -876\n    -104 -905 -112 -146 -43 -266 -162 -317 -314 -19 -55 -21 -81 -18 -165 6 -115\n    28 -183 87 -261 29 -38 969 -913 1254 -1168 l59 -52 -171 -844 c-132 -654\n    -171 -862 -171 -921 0 -137 47 -245 149 -343 139 -132 348 -169 516 -92 28 13\n    382 210 787 439 l738 416 737 -416 c406 -229 761 -426 788 -439 254 -116 569\n    32 649 305 33 113 28 149 -155 1050 l-171 844 59 53 c359 323 1226 1130 1255\n    1169 59 77 81 144 86 260 3 84 0 110 -18 164 -57 171 -192 291 -365 325 -39 8\n    -442 56 -896 107 l-827 93 -303 666 c-433 951 -428 940 -494 1009 -120 126\n    -301 179 -464 135z"/>\n    <path d="M3838 18267 c-87 -30 -171 -88 -224 -156 -31 -40 -119 -221 -325\n    -673 -156 -341 -286 -621 -289 -623 -3 -2 -305 -38 -670 -79 -457 -53 -685\n    -83 -728 -96 -122 -39 -224 -126 -282 -240 -75 -149 -64 -335 29 -482 18 -28\n    225 -225 532 -508 277 -254 505 -468 507 -474 1 -6 -56 -299 -127 -651 -71\n    -352 -132 -665 -136 -695 -13 -108 38 -263 119 -356 45 -53 130 -109 204 -136\n    88 -32 236 -31 318 3 34 14 313 168 620 341 308 173 569 320 581 327 20 10 83\n    -23 610 -320 323 -183 611 -340 641 -351 302 -106 631 127 632 449 0 40 -46\n    289 -130 705 -71 354 -132 653 -135 665 -4 18 73 92 473 459 262 241 496 458\n    520 483 56 59 109 168 123 257 36 227 -110 458 -331 524 -42 13 -303 47 -730\n    96 -366 42 -666 77 -667 78 -2 1 -128 277 -282 612 -153 336 -290 628 -303\n    650 -57 89 -184 179 -289 203 -77 18 -187 13 -261 -12z"/>\n    <path d="M16370 18276 c-104 -28 -209 -102 -270 -192 -17 -23 -156 -318 -310\n    -655 -154 -337 -281 -614 -283 -615 -1 -1 -301 -36 -667 -78 -427 -49 -688\n    -83 -730 -96 -223 -66 -369 -300 -330 -529 14 -85 63 -188 117 -247 21 -23\n    255 -241 521 -484 405 -371 481 -445 477 -463 -3 -12 -64 -312 -135 -666 -84\n    -413 -130 -665 -130 -705 1 -259 226 -479 489 -475 111 1 154 22 774 372 535\n    302 600 336 620 326 12 -7 274 -154 582 -327 308 -174 585 -326 616 -339 241\n    -97 532 40 619 293 44 126 45 117 -105 859 -83 412 -134 684 -129 691 5 6 232\n    217 505 467 273 250 505 468 516 484 192 272 72 644 -239 743 -43 13 -271 43\n    -728 96 -366 41 -668 79 -672 82 -4 4 -133 284 -288 623 -306 669 -319 694\n    -430 767 -112 75 -267 102 -390 68z"/>\n    <path d="M10175 14075 c-237 -52 -389 -186 -519 -460 -60 -125 -62 -134 -95\n    -370 -72 -506 -167 -912 -322 -1383 -321 -972 -850 -1898 -1516 -2654 l-103\n    -117 0 -4480 0 -4479 38 -15 c43 -17 170 -56 292 -89 l85 -23 3750 3 c4057 4\n    3822 0 4020 57 50 14 149 54 220 90 390 193 656 539 751 976 26 119 26 419 0\n    538 -27 126 -61 224 -118 343 l-51 107 102 97 c135 128 218 241 296 399 103\n    208 145 388 145 621 0 253 -67 498 -197 716 l-28 47 77 76 c166 165 274 342\n    348 570 49 153 63 272 57 469 -8 300 -68 473 -270 787 -8 14 0 28 42 75 164\n    183 284 442 327 704 19 116 13 387 -11 495 -125 561 -537 967 -1102 1087\n    l-108 23 -2317 3 c-1699 2 -2318 5 -2318 14 0 6 27 95 61 197 146 448 291 998\n    378 1436 214 1071 208 1938 -17 2620 -208 631 -602 1100 -1162 1384 -173 88\n    -256 120 -350 137 -95 17 -307 16 -385 -1z"/>\n    <path d="M2393 8625 c-392 -71 -685 -363 -765 -765 -19 -96 -19 -6984 0 -7080\n    76 -377 326 -646 700 -753 l77 -22 1764 -3 c1941 -3 1848 -5 2024 58 158 58\n    321 178 421 311 l46 61 0 3887 0 3888 -49 65 c-142 188 -379 326 -614 357\n    -124 17 -3510 13 -3604 -4z m1362 -1280 c99 -21 171 -60 241 -129 104 -104\n    151 -231 141 -376 -10 -144 -86 -275 -205 -357 -109 -74 -155 -83 -447 -83\n    -291 0 -336 8 -447 83 -237 159 -277 499 -84 714 74 82 167 133 276 153 83 14\n    448 11 525 -5z"/>\n    </g>\n    </svg>\n    ',
    name: "Third-Party Reviews",
    questionsList: [
      {
        question: "SOC Provided",
        answer: "yes",
        id: 1,
      },
      {
        question: "SOC Unqualified",
        answer: "yes",
        id: 2,
      },
      {
        question: "Other Third-Party Audit Provided",
        answer: "yes",
        id: 3,
      },
    ],
    id: 3,
  },
  {
    icon: '<?xml version="1.0" standalone="no"?>\n    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"\n     "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">\n    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"\n     width="2047.000000pt" height="2047.000000pt" viewBox="0 0 2047.000000 2047.000000"\n     preserveAspectRatio="xMidYMid meet">\n    \n    <g transform="translate(0.000000,2047.000000) scale(0.100000,-0.100000)"\n    fill="currentColor" stroke="none">\n    <path d="M18545 19869 c-101 -13 -267 -56 -365 -94 -427 -164 -750 -460 -945\n    -867 -107 -222 -153 -409 -162 -654 -7 -189 5 -307 49 -474 16 -63 31 -124 31\n    -134 2 -21 72 21 -1882 -1140 l-954 -567 -61 59 c-308 297 -741 472 -1171 472\n    -589 0 -1160 -325 -1453 -826 -20 -35 -40 -64 -43 -64 -8 0 -617 300 -1673\n    824 -791 392 -838 417 -832 438 14 49 19 297 7 394 -61 501 -330 943 -743\n    1220 -524 352 -1173 388 -1739 98 -743 -382 -1095 -1252 -830 -2052 l37 -113\n    -40 -32 c-23 -18 -225 -170 -451 -338 -225 -168 -935 -697 -1576 -1176 -641\n    -478 -1170 -873 -1176 -876 -6 -4 -66 20 -134 53 -144 69 -262 110 -409 142\n    -92 19 -133 22 -330 22 -196 0 -238 -3 -329 -22 -939 -205 -1524 -1091 -1335\n    -2022 35 -174 134 -416 231 -569 93 -147 270 -339 408 -442 416 -314 954 -423\n    1455 -294 561 144 1015 568 1195 1118 66 202 80 297 80 532 0 222 -17 339 -75\n    511 -23 70 -27 91 -17 100 12 12 3104 2321 3215 2401 l62 45 83 -40 c598 -292\n    1311 -199 1824 238 l71 61 1419 -702 c780 -385 1423 -706 1429 -713 6 -6 19\n    -42 29 -81 24 -94 87 -253 136 -345 243 -451 674 -770 1175 -871 153 -30 409\n    -37 564 -15 329 48 611 174 867 387 382 320 616 832 601 1318 l-3 115 1485\n    883 c817 486 1512 899 1546 918 l61 35 78 -45 c362 -206 818 -267 1228 -163\n    303 76 555 217 780 437 233 227 384 491 469 818 l33 128 0 265 c0 221 -3 279\n    -19 350 -148 679 -669 1195 -1342 1331 -124 25 -435 35 -559 18z"/>\n    <path d="M17543 13049 c-223 -38 -418 -222 -462 -437 -8 -38 -11 -1674 -11\n    -5819 0 -5228 1 -5771 16 -5827 25 -97 71 -174 154 -256 52 -53 96 -86 142\n    -108 133 -65 84 -63 1426 -60 l1217 3 67 26 c159 62 258 151 330 296 l43 86 3\n    5826 c2 5355 1 5830 -14 5876 -58 180 -187 310 -374 377 l-65 23 -1210 1\n    c-665 1 -1233 -2 -1262 -7z"/>\n    <path d="M6134 11905 c-205 -44 -380 -218 -429 -426 -13 -57 -15 -645 -15\n    -5249 0 -4604 2 -5192 15 -5249 50 -210 225 -382 434 -427 99 -21 2414 -20\n    2514 1 206 43 378 211 432 420 13 53 15 636 15 5255 0 4619 -2 5202 -15 5255\n    -28 108 -72 184 -154 265 -86 85 -171 133 -278 155 -97 21 -2425 21 -2519 0z"/>\n    <path d="M11801 9624 c-143 -38 -286 -151 -353 -280 -74 -142 -68 263 -68\n    -4251 0 -4474 -5 -4104 62 -4243 42 -88 158 -203 250 -248 130 -64 84 -62\n    1393 -62 1317 0 1261 -2 1396 65 96 48 201 153 246 246 68 138 63 -225 63\n    4244 0 4482 6 4096 -65 4241 -65 133 -211 250 -361 289 -85 22 -2480 22 -2563\n    -1z"/>\n    <path d="M450 7354 c-211 -45 -391 -224 -435 -431 -13 -58 -15 -490 -15 -2968\n    0 -3210 -5 -2971 67 -3107 69 -131 169 -218 321 -277 l67 -26 1217 -3 c1342\n    -3 1293 -5 1426 60 85 41 204 158 249 243 68 131 63 -126 63 3111 0 2528 -2\n    2936 -15 2984 -55 209 -226 370 -440 415 -101 21 -2405 21 -2505 -1z"/>\n    </g>\n    </svg>\n    ',
    name: "Data Privacy",
    questionsList: [
      {
        question: "Privacy Policy",
        answer: "yes",
        id: 1,
      },
      {
        question: "Exempt Individual Data",
        answer: "yes",
        id: 2,
      },
      {
        question: "Breach Notification",
        answer: "yes",
        id: 3,
      },
    ],
    id: 4,
  },
  {
    icon: '<?xml version="1.0" standalone="no"?>\n    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"\n     "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">\n    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"\n     width="2048.000000pt" height="2048.000000pt" viewBox="0 0 2048.000000 2048.000000"\n     preserveAspectRatio="xMidYMid meet">\n    \n    <g transform="translate(0.000000,2048.000000) scale(0.100000,-0.100000)"\n    fill="currentColor" stroke="none">\n    <path d="M8550 18144 c-103 -37 -186 -127 -210 -224 -7 -32 -10 -2231 -8\n    -7705 l3 -7660 24 -50 c32 -63 92 -124 156 -155 41 -20 65 -25 135 -24 72 0\n    93 4 137 27 69 36 120 88 152 156 l26 56 0 7675 0 7675 -26 56 c-52 111 -150\n    178 -273 185 -50 3 -84 0 -116 -12z"/>\n    <path d="M3647 17830 c-487 -61 -827 -291 -1012 -682 -52 -110 -88 -231 -117\n    -388 -28 -155 -30 -481 -4 -650 108 -707 493 -1243 1011 -1409 125 -41 235\n    -55 374 -48 281 13 533 130 757 352 168 166 290 351 384 582 111 275 160 535\n    160 845 -1 469 -129 814 -396 1068 -171 163 -391 268 -659 315 -104 19 -399\n    28 -498 15z"/>\n    <path d="M10848 17619 c-100 -16 -189 -86 -234 -184 -56 -122 -283 -974 -398\n    -1490 -323 -1454 -505 -2924 -578 -4665 -16 -385 -16 -1695 0 -2080 73 -1741\n    255 -3206 578 -4665 121 -544 346 -1382 404 -1502 92 -187 335 -235 490 -96\n    65 58 101 129 107 208 6 66 7 61 -92 400 -555 1913 -865 4309 -865 6695 0\n    2371 307 4758 856 6660 110 383 107 368 101 435 -14 180 -186 313 -369 284z"/>\n    <path d="M13070 17081 c-98 -32 -146 -79 -299 -290 -997 -1376 -1637 -3287\n    -1810 -5401 -35 -425 -45 -672 -45 -1145 0 -476 10 -736 45 -1155 174 -2117\n    813 -4025 1810 -5401 127 -176 180 -234 243 -267 44 -23 63 -27 141 -27 78 0\n    97 4 141 27 67 35 138 115 160 180 21 64 16 187 -11 238 -10 19 -58 89 -108\n    155 -957 1282 -1577 3125 -1742 5175 -40 506 -52 1272 -26 1740 60 1111 231\n    2097 527 3052 296 955 732 1841 1241 2523 116 155 125 174 131 266 6 100 -14\n    162 -75 229 -64 72 -129 102 -223 106 -41 2 -86 0 -100 -5z"/>\n    <path d="M15310 16544 c-90 -32 -417 -262 -655 -460 -1080 -900 -1870 -2260\n    -2224 -3830 -155 -687 -224 -1308 -224 -2014 0 -353 12 -589 44 -910 207\n    -2050 1070 -3823 2404 -4934 253 -211 570 -431 663 -461 103 -34 235 0 316 81\n    120 120 122 325 5 443 -19 19 -88 70 -154 114 -267 179 -480 353 -719 587\n    -479 470 -822 949 -1141 1595 -971 1963 -1040 4502 -180 6580 79 191 265 571\n    365 745 437 759 1006 1379 1675 1827 66 44 135 95 154 114 117 118 115 323 -5\n    443 -81 81 -224 116 -324 80z"/>\n    <path d="M3225 14420 c-739 -45 -1386 -159 -1789 -314 -562 -218 -890 -559\n    -946 -987 -8 -59 -10 -660 -8 -2049 l3 -1965 27 -100 c95 -357 322 -642 645\n    -808 85 -44 250 -107 279 -107 12 0 14 272 16 1883 l3 1882 28 57 c54 109 146\n    169 273 176 73 4 88 1 143 -23 76 -35 142 -104 170 -181 l21 -55 0 -4594 0\n    -4595 745 0 745 0 2 2268 3 2267 23 47 c30 60 90 120 150 150 69 34 206 33\n    276 -1 98 -48 157 -130 176 -242 6 -43 10 -801 10 -2276 l0 -2213 690 0 690 0\n    2 4603 3 4602 26 55 c56 121 143 181 270 188 112 6 168 -15 244 -92 105 -105\n    95 103 95 -2038 l0 -1870 38 7 c20 4 78 22 127 41 275 106 518 316 663 575 49\n    86 99 225 122 337 20 101 20 113 18 2109 l-3 2008 -23 80 c-137 476 -586 808\n    -1332 984 -338 80 -731 137 -1220 177 -225 19 -1174 28 -1405 14z"/>\n    <path d="M15928 12268 c-42 -20 -2293 -1934 -2309 -1964 -17 -34 -17 -95 0\n    -128 20 -36 2272 -1948 2316 -1965 42 -16 93 -8 130 21 54 42 55 50 55 538 l0\n    450 1833 2 1832 3 57 28 c61 30 95 64 131 131 l22 41 0 815 0 815 -22 41 c-36\n    67 -70 101 -131 131 l-57 28 -1832 3 -1833 2 0 453 c0 496 0 495 -61 540 -33\n    24 -96 31 -131 15z"/>\n    </g>\n    </svg>\n    ',
    name: "Resiliency",
    questionsList: [
      {
        question: "N+1 or Better Infrastructure",
        answer: "no",
        id: 1,
      },
      {
        question: "Monitoring/Maintenance",
        answer: "no",
        id: 2,
      },
      {
        question: "Backup Practicies",
        answer: "no",
        id: 3,
      },
    ],
    id: 5,
  },
  {
    icon: '<?xml version="1.0" standalone="no"?>\n    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"\n     "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">\n    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"\n     width="2048.000000pt" height="2048.000000pt" viewBox="0 0 2048.000000 2048.000000"\n     preserveAspectRatio="xMidYMid meet">\n    \n    <g transform="translate(0.000000,2048.000000) scale(0.100000,-0.100000)"\n    fill="currentColor" stroke="none">\n    <path d="M1600 19889 c-762 -86 -1397 -661 -1558 -1409 -85 -396 -38 -792 138\n    -1157 171 -356 449 -643 792 -818 260 -134 480 -191 768 -202 705 -25 1363\n    369 1672 1003 30 60 61 128 70 152 l16 42 1031 0 1031 0 -2 -742 -3 -742 -160\n    -64 c-558 -221 -1298 -481 -2000 -703 -159 -50 -317 -105 -350 -122 -83 -44\n    -191 -155 -237 -242 -68 -131 -81 -227 -100 -743 -25 -690 34 -1631 152 -2406\n    11 -71 20 -137 20 -147 0 -18 -46 -18 -1192 -21 -1126 -3 -1196 -4 -1248 -22\n    -315 -105 -491 -398 -426 -707 42 -194 194 -368 387 -440 l64 -24 1329 -5\n    1329 -5 54 -210 c91 -357 200 -725 316 -1075 62 -184 113 -341 115 -347 3 -10\n    -175 -13 -865 -13 -751 0 -877 -2 -928 -15 -198 -52 -364 -211 -425 -410 -32\n    -103 -30 -243 4 -351 59 -185 201 -327 391 -392 l80 -27 1118 -3 1117 -3 32\n    -72 c269 -603 711 -1404 1133 -2052 180 -276 529 -769 688 -970 l47 -60 -1243\n    -3 c-683 -1 -1247 0 -1253 2 -6 2 -19 26 -29 53 -85 229 -265 491 -458 668\n    -436 399 -1025 558 -1606 433 -175 -37 -374 -116 -529 -210 -481 -290 -794\n    -767 -867 -1321 -87 -669 218 -1338 784 -1718 605 -407 1393 -408 1996 -4 272\n    182 477 416 620 710 35 72 67 142 70 157 l7 28 1764 0 1763 0 363 -363 c539\n    -540 948 -907 1527 -1371 388 -311 974 -739 1077 -788 159 -75 349 -75 508 0\n    103 49 689 477 1077 788 579 464 988 831 1527 1371 l363 363 1763 0 1764 0 7\n    -27 c3 -16 35 -86 70 -158 143 -294 348 -528 620 -710 603 -404 1391 -403\n    1996 4 270 181 483 428 623 723 462 968 -23 2116 -1045 2473 -329 114 -732\n    125 -1069 28 -486 -139 -894 -479 -1118 -928 -27 -55 -57 -122 -67 -148 -10\n    -27 -23 -51 -29 -53 -6 -2 -570 -3 -1253 -2 l-1243 3 47 60 c159 201 508 694\n    688 970 422 648 864 1449 1133 2052 l32 72 1117 3 1118 3 81 27 c189 65 331\n    207 390 393 34 107 36 247 4 350 -61 199 -227 358 -425 410 -51 13 -177 15\n    -928 15 -690 0 -868 3 -865 13 2 6 53 163 115 347 116 350 225 718 316 1075\n    l54 210 1329 5 1329 5 64 24 c193 72 345 246 387 440 65 309 -111 602 -426\n    707 -52 18 -122 19 -1247 22 -1147 3 -1193 3 -1193 21 0 10 9 76 20 147 118\n    775 177 1716 152 2406 -19 516 -32 612 -100 743 -46 87 -154 198 -237 242 -33\n    17 -190 72 -350 122 -702 222 -1442 482 -2000 703 l-160 64 -3 742 -2 742\n    1031 0 1031 0 16 -42 c9 -24 40 -92 70 -152 227 -465 650 -812 1154 -946 357\n    -94 755 -74 1091 56 839 323 1313 1192 1125 2064 -102 474 -406 903 -820 1154\n    -917 557 -2091 206 -2562 -764 -26 -52 -52 -112 -58 -132 l-11 -38 -1361 0\n    c-1506 0 -1433 3 -1571 -66 -140 -69 -247 -192 -302 -349 l-28 -80 -5 -833 -5\n    -833 -330 165 c-953 475 -1690 935 -2265 1415 -110 92 -348 323 -455 443 -112\n    123 -250 183 -425 183 -175 0 -313 -60 -425 -183 -107 -120 -345 -351 -455\n    -443 -575 -480 -1312 -940 -2265 -1415 l-330 -165 -5 833 -5 833 -28 80 c-55\n    157 -162 280 -302 349 -138 69 -65 66 -1571 66 l-1361 0 -11 38 c-6 20 -32 80\n    -58 132 -278 573 -811 951 -1436 1019 -111 13 -278 12 -388 0z m8995 -5193\n    c395 -59 762 -200 1080 -417 526 -358 898 -887 1053 -1494 62 -245 82 -429 82\n    -781 l0 -240 78 -34 c330 -145 575 -459 637 -818 22 -127 22 -3677 0 -3804\n    -70 -401 -354 -728 -745 -856 -165 -54 -55 -52 -2540 -52 -2485 0 -2375 -2\n    -2540 52 -331 108 -586 357 -699 682 -64 182 -61 80 -61 2076 0 1978 -2 1891\n    56 2065 95 286 321 534 597 655 l77 34 0 240 c0 352 20 536 82 781 89 348 265\n    700 495 985 191 238 476 477 751 629 277 154 622 266 922 300 52 6 111 13 130\n    15 73 9 449 -4 545 -18z"/>\n    <path d="M10035 13504 c-437 -68 -820 -346 -1018 -740 -48 -96 -95 -231 -119\n    -344 -15 -75 -21 -149 -25 -347 l-5 -253 1372 0 1372 0 -5 253 c-6 279 -19\n    367 -77 532 -220 619 -852 999 -1495 899z"/>\n    <path d="M8140 9010 l0 -1610 2100 0 2100 0 0 1610 0 1610 -2100 0 -2100 0 0\n    -1610z m2290 781 c180 -62 310 -194 382 -388 20 -53 22 -81 26 -356 4 -340 -3\n    -393 -65 -520 -47 -92 -162 -211 -248 -254 -113 -57 -160 -68 -285 -68 -125 0\n    -172 11 -285 68 -86 43 -201 162 -248 254 -62 127 -69 180 -65 520 5 324 5\n    330 71 459 71 140 222 258 383 299 86 21 250 14 334 -14z"/>\n    </g>\n    </svg>\n    ',
    name: "Physical Security",
    questionsList: [
      {
        question: "Electronic Access Control",
        answer: "yes",
        id: 1,
      },
      {
        question: "Periodic Access Reviews",
        answer: "yes",
        id: 2,
      },
      {
        question: "Security Cameras",
        answer: "no",
        id: 3,
      },
    ],
    id: 6,
  },
  {
    icon: '<?xml version="1.0" standalone="no"?>\n    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"\n     "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">\n    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"\n     width="2048.000000pt" height="2048.000000pt" viewBox="0 0 2048.000000 2048.000000"\n     preserveAspectRatio="xMidYMid meet">\n    \n    <g transform="translate(0.000000,2048.000000) scale(0.100000,-0.100000)"\n    fill="currentColor" stroke="none">\n    <path d="M5718 17406 l-4518 -1871 0 -567 0 -568 9040 0 9040 0 0 568 0 567\n    -4516 1870 c-2484 1029 -4519 1871 -4523 1871 -3 1 -2039 -840 -4523 -1870z"/>\n    <path d="M0 12600 l0 -600 600 0 600 0 0 -3600 0 -3600 1200 0 1200 0 0 2140\n    c0 1449 3 2172 11 2238 36 335 170 665 372 921 311 393 748 636 1239 690 786\n    87 1549 -362 1859 -1095 79 -187 120 -351 138 -560 7 -78 11 -845 11 -2226 l0\n    -2108 600 0 600 0 0 2168 c0 2374 -2 2255 60 2487 121 456 418 846 833 1094\n    487 293 1103 331 1634 101 507 -218 892 -664 1033 -1195 62 -232 60 -113 60\n    -2487 l0 -2168 600 0 600 0 0 2108 c0 1381 4 2148 11 2226 18 209 59 373 138\n    560 204 481 605 849 1106 1015 512 170 1095 94 1548 -202 457 -298 757 -786\n    816 -1329 8 -66 11 -789 11 -2238 l0 -2140 1200 0 1200 0 0 3600 0 3600 600 0\n    600 0 0 600 0 600 -10240 0 -10240 0 0 -600z"/>\n    <path d="M5262 9580 c-175 -46 -317 -162 -398 -325 -68 -138 -64 12 -64 -2332\n    l0 -2123 615 0 615 0 -2 2148 c-3 2057 -4 2149 -21 2202 -76 225 -252 390\n    -463 435 -93 20 -194 18 -282 -5z"/>\n    <path d="M10140 9594 c-102 -20 -231 -83 -307 -149 -64 -56 -143 -172 -174\n    -256 l-24 -64 -3 -2162 -2 -2163 610 0 610 0 -2 2163 -3 2162 -24 64 c-89 239\n    -306 397 -556 406 -55 2 -111 1 -125 -1z"/>\n    <path d="M14932 9585 c-210 -47 -384 -213 -459 -435 -17 -53 -18 -145 -21\n    -2202 l-2 -2148 615 0 615 0 -2 2153 -3 2152 -22 65 c-65 189 -219 343 -403\n    401 -84 27 -232 34 -318 14z"/>\n    <path d="M0 2400 l0 -1200 10240 0 10240 0 0 1200 0 1200 -10240 0 -10240 0 0\n    -1200z"/>\n    </g>\n    </svg>\n    ',
    name: "Information Security Governance",
    questionsList: [
      {
        question: "Information Security Policy",
        answer: "yes",
        id: 1,
      },
      {
        question: "Asset Management",
        answer: "no",
        id: 2,
      },
      {
        question: "Employee/Contractor Security",
        answer: "yes",
        id: 3,
      },
    ],
    id: 7,
  },
  {
    icon: '<?xml version="1.0" standalone="no"?>\n    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"\n     "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">\n    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"\n     width="2475.000000pt" height="2475.000000pt" viewBox="0 0 2475.000000 2475.000000"\n     preserveAspectRatio="xMidYMid meet">\n    \n    <g transform="translate(0.000000,2475.000000) scale(0.100000,-0.100000)"\n    fill="currentColor" stroke="none">\n    <path d="M11401 24543 c-24 -115 -68 -323 -98 -463 -29 -140 -76 -360 -103\n    -489 -26 -129 -53 -237 -59 -241 -6 -3 -66 -19 -134 -34 -731 -165 -1361 -424\n    -2041 -839 l-158 -97 -312 202 c-171 111 -394 256 -496 323 -102 67 -232 152\n    -289 189 l-104 68 -679 -679 c-373 -373 -678 -682 -678 -688 0 -5 25 -68 54\n    -140 50 -119 83 -200 243 -580 30 -71 79 -191 110 -265 30 -74 60 -141 66\n    -149 6 -7 48 -30 94 -51 234 -108 543 -327 762 -539 47 -44 85 -80 87 -78 1 1\n    49 72 106 158 399 595 933 1128 1528 1525 790 528 1725 852 2665 924 180 14\n    652 14 825 0 747 -59 1456 -260 2115 -599 837 -431 1549 -1061 2073 -1836 52\n    -77 96 -142 98 -144 2 -2 47 37 101 87 227 209 469 374 736 501 l118 56 160\n    375 c88 206 179 420 203 475 25 55 61 142 82 193 l38 93 -680 680 -681 681\n    -204 -134 c-112 -74 -383 -250 -602 -392 l-397 -258 -43 27 c-317 210 -754\n    438 -1147 598 -281 114 -575 207 -943 297 -109 27 -201 51 -204 53 -3 3 -27\n    111 -54 239 -26 128 -75 361 -109 518 -33 157 -77 365 -98 463 l-37 177 -935\n    0 -936 0 -43 -207z"/>\n    <path d="M12015 21750 c-282 -23 -643 -91 -934 -175 -1070 -309 -1996 -990\n    -2621 -1929 -74 -111 -250 -412 -250 -428 0 -5 22 -57 49 -116 148 -325 243\n    -701 271 -1078 8 -100 10 -333 7 -685 -4 -478 -6 -548 -25 -664 -94 -587 -292\n    -1047 -641 -1485 -137 -173 -404 -426 -578 -549 l-33 -22 0 -104 0 -104 38\n    -10 c374 -97 1650 -411 1667 -411 17 0 1271 309 1668 411 l37 10 0 104 0 104\n    -32 22 c-173 121 -391 324 -545 509 -406 486 -647 1079 -693 1710 -13 176 -13\n    1096 0 1270 38 511 196 989 465 1405 356 550 900 983 1510 1200 388 138 849\n    199 1235 165 529 -48 1005 -223 1444 -532 267 -188 520 -440 719 -715 343\n    -475 545 -1037 587 -1628 13 -182 13 -991 0 -1165 -46 -631 -287 -1224 -693\n    -1710 -154 -185 -372 -388 -544 -509 l-33 -22 0 -104 0 -104 38 -10 c396 -102\n    1650 -411 1667 -411 17 0 1293 314 1668 411 l37 10 0 104 0 104 -32 22 c-175\n    123 -442 376 -579 549 -161 202 -284 400 -388 627 -154 333 -243 676 -272\n    1046 -17 222 -6 1281 14 1421 50 337 144 663 256 884 17 34 31 70 31 80 0 42\n    -257 449 -414 657 -201 265 -489 564 -751 778 -305 250 -564 417 -920 592\n    -307 152 -630 271 -961 354 -118 30 -439 87 -594 106 -158 20 -703 29 -875 15z"/>\n    <path d="M5260 20035 c-286 -42 -515 -119 -752 -252 -596 -336 -1004 -947\n    -1077 -1615 -14 -125 -14 -1221 -1 -1343 45 -396 219 -805 476 -1116 85 -102\n    272 -280 372 -354 44 -33 157 -105 249 -161 l168 -100 0 -675 0 -674 -477\n    -119 c-263 -66 -478 -123 -478 -127 0 -4 21 -19 48 -34 26 -15 88 -51 137 -80\n    272 -160 641 -375 720 -420 110 -63 596 -347 720 -420 138 -81 494 -288 552\n    -321 29 -16 54 -33 56 -39 1 -5 -1 -185 -5 -400 -7 -303 -12 -402 -24 -444 -8\n    -29 -14 -55 -12 -57 4 -3 90 15 583 125 149 33 373 83 499 111 126 28 233 53\n    238 56 4 3 8 106 8 230 0 340 21 485 110 754 89 271 251 550 438 751 30 33 52\n    62 48 66 -3 3 -331 88 -729 187 l-722 181 -2 675 -3 675 123 70 c153 87 290\n    179 387 260 86 72 246 235 309 315 174 221 325 519 391 775 64 250 65 261 65\n    930 0 544 -2 622 -18 718 -72 429 -241 804 -501 1114 -352 421 -818 685 -1338\n    758 -131 18 -435 18 -558 0z"/>\n    <path d="M12090 20035 c-490 -71 -898 -279 -1241 -632 -267 -275 -438 -578\n    -533 -944 -62 -241 -61 -222 -61 -969 0 -619 2 -694 18 -775 43 -217 97 -384\n    181 -560 109 -227 221 -388 396 -569 168 -173 308 -279 557 -421 l123 -70 -3\n    -675 -2 -675 -1240 -310 c-682 -171 -1265 -319 -1295 -329 -381 -127 -684\n    -427 -810 -805 -46 -136 -61 -224 -67 -383 -5 -134 -4 -148 11 -148 9 0 97 18\n    195 40 605 134 1183 164 1796 95 385 -44 678 -114 1255 -300 91 -29 266 -85\n    390 -125 124 -39 293 -93 375 -120 83 -27 238 -76 345 -110 107 -34 277 -89\n    377 -121 141 -46 196 -59 243 -59 73 0 224 -16 340 -35 80 -14 307 -75 795\n    -215 586 -167 904 -258 1140 -325 72 -20 198 -56 280 -80 83 -24 254 -73 381\n    -109 l230 -66 142 0 c133 0 146 2 193 25 l50 26 -4 892 c-4 980 0 919 -67\n    1118 -126 378 -429 678 -810 805 -30 10 -613 158 -1295 329 l-1240 310 -2 675\n    -3 675 123 70 c250 143 392 250 562 426 284 293 468 644 562 1074 l26 120 4\n    595 c5 622 1 705 -39 890 -72 337 -191 608 -394 895 -100 143 -349 393 -489\n    492 -303 214 -586 328 -939 378 -123 18 -436 18 -556 0z"/>\n    <path d="M18920 20035 c-367 -53 -671 -176 -970 -393 -137 -99 -363 -326 -463\n    -464 -196 -270 -316 -553 -380 -893 -21 -117 -22 -139 -22 -785 0 -730 0 -732\n    65 -985 58 -224 191 -502 338 -705 93 -128 323 -362 447 -453 50 -36 149 -101\n    220 -143 72 -42 147 -87 168 -100 l37 -24 -2 -673 -3 -672 -722 -181 c-398\n    -99 -726 -184 -729 -187 -4 -4 18 -33 48 -66 221 -238 390 -552 482 -894 60\n    -220 60 -215 66 -973 l5 -701 565 297 c949 498 1750 919 2060 1083 403 213\n    979 516 1567 824 270 142 489 260 487 263 -3 3 -481 124 -1062 270 l-1057 265\n    0 674 0 675 168 100 c216 130 303 195 449 335 136 130 212 221 311 371 146\n    221 262 506 314 769 l27 136 4 570 c2 377 0 607 -8 680 -41 410 -208 829 -459\n    1155 -313 406 -761 698 -1221 795 -214 45 -536 59 -730 30z"/>\n    <path d="M2 11028 l3 -3901 910 -304 c500 -166 912 -299 916 -295 8 8 1552\n    6183 1547 6187 -4 3 -359 237 -768 505 -162 106 -365 239 -450 295 -85 56\n    -281 184 -435 285 -154 101 -350 229 -435 285 -85 56 -294 193 -465 305 -171\n    112 -395 259 -500 328 -104 69 -220 145 -258 169 l-67 43 2 -3902z"/>\n    <path d="M24690 13557 c-74 -38 -883 -463 -1050 -552 -149 -80 -644 -340\n    -1911 -1005 -323 -170 -620 -326 -660 -348 -69 -38 -413 -218 -1824 -959 -319\n    -168 -611 -322 -650 -343 -38 -21 -335 -178 -660 -348 -324 -170 -723 -379\n    -885 -465 l-295 -156 -327 9 -327 9 -863 246 c-475 135 -915 261 -978 280 -63\n    19 -158 46 -210 60 -52 14 -156 44 -230 65 -569 165 -594 171 -850 177 -279 8\n    -463 -22 -710 -114 -128 -48 -2559 -1264 -2636 -1319 -61 -43 -138 -134 -174\n    -204 -54 -106 -75 -313 -46 -450 46 -220 217 -398 430 -449 101 -25 248 -14\n    348 26 24 9 345 197 713 418 1056 633 1059 634 1185 686 221 92 412 129 655\n    129 220 0 410 -32 581 -96 252 -94 415 -197 648 -409 61 -56 156 -141 211\n    -190 56 -50 348 -313 650 -585 302 -272 569 -513 594 -535 25 -22 116 -103\n    201 -180 217 -197 933 -842 1055 -950 56 -49 280 -252 499 -449 l398 -359\n    3589 1794 3589 1794 0 2397 c0 1319 -3 2398 -7 2398 -5 0 -28 -11 -53 -23z"/>\n    <path d="M4145 12248 c-4 -11 -1489 -5952 -1498 -5989 -3 -14 819 -290 853\n    -287 22 3 27 13 53 108 16 58 48 173 72 255 63 217 141 490 185 645 36 131 67\n    237 170 595 27 94 295 1031 595 2083 508 1781 546 1917 543 1978 l-3 67 -120\n    70 c-66 38 -160 93 -210 122 -49 28 -211 122 -358 208 -148 87 -270 157 -273\n    157 -3 0 -7 -6 -9 -12z"/>\n    <path d="M9280 11083 c-352 -23 -499 -46 -910 -137 -779 -172 -1765 -391\n    -1940 -431 -107 -24 -280 -62 -385 -86 -104 -23 -232 -51 -284 -63 -54 -12\n    -98 -27 -103 -36 -17 -29 -1147 -4005 -1140 -4012 13 -13 1293 -778 1301 -778\n    5 0 20 17 34 38 15 20 235 244 489 498 333 331 485 475 541 513 90 61 252 140\n    349 169 322 99 670 75 966 -68 286 -138 498 -350 632 -633 74 -157 99 -245\n    127 -462 l8 -60 76 -7 c167 -15 347 -70 498 -151 293 -157 517 -420 629 -737\n    34 -99 50 -170 66 -295 l11 -90 80 -7 c148 -14 309 -59 450 -128 258 -125 481\n    -350 615 -617 67 -135 130 -375 130 -495 0 -38 0 -38 43 -38 23 0 85 -7 137\n    -15 377 -62 724 -306 927 -652 l48 -83 490 -408 c270 -224 517 -424 550 -444\n    77 -46 167 -76 271 -90 209 -28 392 65 484 246 31 62 35 79 38 166 8 189 -37\n    269 -249 447 -271 227 -857 715 -1646 1371 -276 229 -502 419 -503 422 0 8\n    531 644 541 648 5 2 96 -68 202 -157 1937 -1616 2155 -1796 2212 -1822 145\n    -68 354 -65 497 7 153 78 256 282 229 453 -12 73 -55 170 -96 220 -16 18 -539\n    458 -1161 977 -623 519 -1135 948 -1138 952 -6 10 524 651 539 651 6 0 537\n    -438 1180 -975 839 -700 1187 -983 1230 -1005 143 -70 351 -66 488 8 231 126\n    309 418 173 647 -32 53 -67 86 -541 512 -220 198 -647 582 -949 854 -303 272\n    -618 556 -700 630 -83 74 -380 341 -661 594 -280 252 -595 535 -698 628 -195\n    175 -257 221 -364 270 -223 101 -518 96 -733 -12 -44 -22 -439 -256 -878 -519\n    -439 -264 -839 -499 -888 -524 -103 -51 -241 -98 -369 -124 -136 -27 -395 -24\n    -535 6 -148 32 -249 67 -369 128 -389 199 -662 555 -753 982 -26 124 -36 409\n    -18 548 44 351 212 672 474 902 128 112 253 180 1339 722 598 299 1087 546\n    1087 549 0 3 -53 22 -118 42 -64 20 -209 66 -322 102 -514 166 -822 229 -1250\n    256 -152 9 -371 11 -480 3z"/>\n    <path d="M7555 5959 c-33 -5 -94 -25 -135 -45 -71 -34 -99 -61 -501 -463 -403\n    -403 -429 -430 -463 -501 -134 -279 12 -597 311 -675 120 -31 261 -10 365 57\n    87 55 851 819 906 906 67 104 88 245 57 365 -63 242 -292 393 -540 356z"/>\n    <path d="M8854 4679 c-71 -9 -142 -34 -200 -70 -64 -41 -853 -829 -893 -894\n    -47 -75 -72 -166 -72 -261 0 -190 102 -347 279 -432 63 -30 86 -36 167 -40\n    114 -6 199 17 290 77 89 59 863 840 903 911 49 89 65 160 60 266 -4 79 -10\n    103 -40 166 -93 196 -287 304 -494 277z"/>\n    <path d="M10120 3400 c-56 -10 -138 -42 -190 -75 -53 -33 -853 -834 -886 -886\n    -14 -23 -36 -69 -49 -103 -47 -126 -41 -237 19 -363 125 -263 449 -354 692\n    -194 79 52 862 839 899 904 141 246 46 552 -208 673 -67 32 -163 56 -212 53\n    -11 -1 -40 -5 -65 -9z"/>\n    <path d="M11330 2101 c-30 -9 -75 -30 -100 -45 -68 -42 -874 -849 -915 -916\n    -45 -75 -65 -149 -65 -245 0 -139 50 -255 148 -348 159 -148 411 -168 593 -47\n    24 16 231 217 460 447 441 442 451 455 484 580 64 245 -83 506 -324 577 -73\n    21 -210 20 -281 -3z"/>\n    <path d="M12639 1009 c-69 -132 -148 -231 -351 -435 l-190 -192 38 -35 c201\n    -180 334 -289 382 -313 54 -28 64 -29 208 -32 86 -2 169 1 191 7 113 31 241\n    148 284 261 31 78 37 203 14 287 -31 113 -75 165 -302 354 -112 93 -210 172\n    -218 175 -9 4 -27 -22 -56 -77z"/>\n    </g>\n    </svg>\n    ',
    name: "Business Continuity",
    questionsList: [
      {
        question: "Vendor Maintains a BCP",
        answer: "yes",
        id: 1,
      },
      {
        question: "BCP Tested Annually",
        answer: "yes",
        id: 2,
      },
      {
        question: "RTO and RPO",
        answer: "yes",
        id: 3,
      },
    ],
    id: 8,
  },
];

export const BusinessDomainTypes = {
  Sections: "1",
  Table: "2",
  List: "3",
};

export const getGUID = () =>
  Date.now().toString(36) + Math.random().toString(36).substring(2);

export const capitalizeFirstLetter = (string) => {
  if (string?.length > 0)
    return string.charAt(0).toUpperCase() + string.slice(1);
  else return "";
};

export const EnumRemediationStatus = {
  WithVendor: "WithVendor",
  WithAssessor: "WithAssessor",
};

export const EnumRemediationGapStatus = {
  Initiated: "Initiated",
  Draft: "Draft",
  SubmittedToBeaconer: "SubmittedToBeaconer",
  ClientReview: "ClientReview",
  Closed: "Closed",
  OnHold: "OnHold",
};
